import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

export const Process = () => {
  const t = useT();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB]">
              {t.process.eyebrow}
            </p>
          </Reveal>
          <Reveal delay={60}>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A2342] tracking-tight leading-[1.1]">
              {t.process.title}
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-5 text-base lg:text-lg text-slate-600 leading-relaxed">
              {t.process.body}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 relative">
          <div
            className="hidden lg:block absolute top-7 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent"
            aria-hidden="true"
          />
          <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
            {t.process.steps.map((s, i) => (
              <Reveal key={s.title} delay={80 * i}>
                <li
                  data-testid={`process-step-${i}`}
                  className="relative"
                >
                  <div className="relative flex items-center justify-center w-14 h-14 rounded-2xl bg-[#0A2342] text-white font-bold text-sm tracking-wider shadow-lg shadow-[#0A2342]/15">
                    {String(i + 1).padStart(2, "0")}
                    <span className="absolute -bottom-1 -right-1 w-3 h-3 rounded-full bg-[#10B981] ring-2 ring-white" />
                  </div>
                  <h3 className="mt-6 text-xl font-bold text-[#0A2342]">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed max-w-xs">
                    {s.desc}
                  </p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Process;
